import { render, staticRenderFns } from "./FundingSplitBreakdown.vue?vue&type=template&id=9640372a&"
import script from "./FundingSplitBreakdown.vue?vue&type=script&lang=js&"
export * from "./FundingSplitBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports